import React from "react";
import CountUp from 'react-countup';


const Stats = () => {
    const StatData = [
    {
        start: 0,
        end: 30,
        delay: 0,
        duration: 1.5,
        decimal: "",
        decimals: 0,
        prefix: "",
        suffix: "%",
        label: "Less Expensive than a W-2 Employee",
    },
    {
        start: 0,
        end: 1.2,
        delay: 1.5,
        duration: 1.5,
        decimal: ".",
        decimals: 1,
        prefix: "$",
        suffix: "M",
        label: "Saved in Labor Expenses ",
    },
    {
        start: 0,
        end: 60,
        duration: 1.5,
        delay: 2.6,
        decimal: "",
        decimals: 0,
        prefix: "",
        suffix: "%",
        label: "Per Project Profitability Increase",
    },
    {
        start: 0,
        end: 2.0,
        duration: 1.5,
        delay: 4.5,
        decimal: ".",
        decimals: 1,
        prefix: "$",
        suffix: "+",
        label: "Million in Managed Projects",
    }
]



    return (
        <div className="flex flex-col w-full">
            <div className="flex flex-row flex-nowrap md:flex-wrap justify-start items-start text-white font-bold gap-6">
                {StatData.map((stat, index) => (
                    <div key={index} className={`w-1/2 md:w-1/4 max-w-[160px] text-left flex flex-col items-start gap-1 ${index >= 2 ? 'hidden md:flex' : 'flex'}`}>
                        <CountUp
                            start={stat.start}
                            end={stat.end}
                            duration={stat.duration}
                            delay={stat.delay}
                            decimal={stat.decimal}
                            decimals={stat.decimals}
                            prefix={stat.prefix}
                            suffix={stat.suffix}
                            scrollSpyOnce={true}
                            enableScrollSpy={true}
                            className="text-3xl"
                        />
                        <h4 className="text-base font-normal pointer-events-none">{stat.label}</h4>
                    </div>
                ))}

            </div>
        </div>
    )

}

export default Stats;